import React from "react";
import { HelpCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function CalculatorField({ label, value, onChange, unit, tooltip, placeholder }) {
  return (
    <label className="block rounded-2xl border border-border bg-background p-4 shadow-sm">
      <span className="mb-2 flex items-center gap-2 text-sm font-black text-foreground">
        {label}
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <HelpCircle className="h-4 w-4 cursor-help text-primary" />
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p>{tooltip}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </span>
      <div className="flex items-center gap-2">
        <Input
          type="number"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          className="bg-card text-lg font-bold"
        />
        <span className="min-w-12 rounded-full bg-muted px-3 py-2 text-center text-xs font-black text-muted-foreground">{unit}</span>
      </div>
    </label>
  );
}